import { useTranslation } from "react-i18next";
import SectionHead from "../../components/shared/SectionHead";
import TestCard from "./TestCard";
import { TESTIMONIALS } from "./testimonials";

export default function Testimonials() {
  const { t } = useTranslation("landing");

  return (
    <section
      id="testimonials"
      className="scroll-mt-24 bg-canvas-2 py-16 sm:py-20 lg:py-24"
    >
      <div className="mx-auto max-w-container px-5 sm:px-7">
        <SectionHead
          eyebrow={t("test.eyebrow")}
          title1={t("test.title1")}
          titleGrad={t("test.titleGrad")}
          subtitle={t("test.sub")}
        />

        <div className="grid grid-cols-1 gap-5 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((item, i) => (
            <TestCard key={item.key} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}